import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api";

export const fetchDashboardPets = createAsyncThunk(
  "dashboard/fetchDashboardPets",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api({ auth: true }).get("/clinic/dashboard/pets");
      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    species: {},
    breeds: {},
    loading: false,
        error: null,
         dashboardData: null, 
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardPets.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboardPets.fulfilled, (state, action) => {
        state.loading = false;
        state.species = action.payload.species || {};
        state.breeds = action.payload.breeds || {};
        state.dashboardData = action.payload; 
      })
      .addCase(fetchDashboardPets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dashboardSlice.reducer;
